module.exports = __webpack_public_path__ + "static/media/black_mpl-logo.820429dd.png";